import { Anchor, Text } from "@mantine/core";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";

type TokenDescriptionProps = {
  description: string;
};

export const TokenDescription = ({ description }: TokenDescriptionProps) => (
  <Text size="sm">
    <ReactMarkdown
      remarkPlugins={[gfm]}
      components={{
        a: (props) => (
          <Anchor
            {...props}
            sx={{
              fontSize: 14,
              textDecoration: "underline",
              wordBreak: "break-word",
            }}
          />
        ),
        img: (props) => {
          if (props.src?.startsWith("https://www.youtube.com/embed/")) {
            return (
              <iframe
                width="100%"
                style={{ aspectRatio: "16/9" }}
                src={props.src}
                title={props.alt ?? "YouTube embed"}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            );
          }
          return <img {...props} style={{ maxWidth: "100%" }} />;
        },
      }}
    >
      {description ?? ""}
    </ReactMarkdown>
  </Text>
);
